import type { TableView } from 'owa-mail-list-store';
import { action } from 'satcheljs';

/**
 * Initialize selection on load
 * @param tableView where the operation is being performed
 */
export interface INIT_TABLE_SELECTION_ON_LOADActionMessage {
    tableView: TableView;
    isUserNavigation: boolean | undefined;
}
export const initTableSelectionOnLoad: (
    tableView: TableView,
    isUserNavigation?: boolean
) => INIT_TABLE_SELECTION_ON_LOADActionMessage = action(
    'INIT_TABLE_SELECTION_ON_LOAD',
    (
        tableView: TableView,
        isUserNavigation?: boolean
    ): INIT_TABLE_SELECTION_ON_LOADActionMessage => ({
        tableView,
        isUserNavigation,
    })
);
